<template>
  <b-modal
    :visible="visible"
    @ok="deleteData"
    button-size="sm"
    modal-cancel="false"
    no-close-on-backdrop
    @close="close"
    id="course-offered-delete"
  >
    <template v-slot:modal-title>Eliminar el curso ofertado</template>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div v-if="loadedData">
            <p>
              ¿Está seguro de eliminar el curso ofertado con id
              <b>{{ courseOffered.id }}</b
              >?
            </p>
          </div>
          <h4 class="text-center" v-else>Cargando ...</h4>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer="{ ok }">
      <b-button size="sm" variant="secondary" class="float-left" @click="close">
        <CIcon size="sm" name="cil-x-circle" /> Cancelar
      </b-button>
      <b-button
        size="sm"
        variant="danger"
        class="float-right"
        :disabled="!loadedData || loaderDelete"
        @click="ok()"
      >
        <span v-if="!loaderDelete">
          <CIcon size="sm" name="cil-trash" /> Eliminar</span
        >
        <span v-if="loaderDelete">
          Cargando
          <CSpinner color="success" size="sm" /> </span
      ></b-button>
    </template>
  </b-modal>
</template>
<script>
import { BModal, BButton } from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
//services
import CoursesOffered from "@/plugins/services/courses-offered";

export default {
  name: "CourseOfferedDeleteModal",
  components: { BModal, BButton },
  props: {
    modShowDelCourseOffered: { type: Boolean, required: true },
    course_offered_id: { type: Number, required: true },
  },
  data() {
    return {
      courseOffered: {},
      loadedData: false,
      loaderDelete: false,
      dataEmit: { modalShow: false, data: null, status: 200 },
    };
  },
  mounted() {
    this.loadedData = false;
    this.loaderDelete = false;
    this.getData();
  },
  computed: {
    visible() {
      return this.modShowDelCourseOffered;
    },
  },
  methods: {
    getData() {
      CoursesOffered.getOne(this.course_offered_id)
        .then((res) => {
          this.courseOffered = res.data;
          this.loadedData = true;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Curso ofertado no encontrado.");
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal(null, 500);
          }
          this.loadedData = true;
        });
    },
    deleteData() {
      this.loaderDelete = false;
      CoursesOffered.delete(this.course_offered_id)
        .then((res) => {
          this.loaderDelete = true;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("danger", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.loaderDelete = true;
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", err.response.data.data);
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal(null, 500);
          }
        });
    },
    closeModal(data = null, status = 200) {
      this.courseOffered = {};
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.dataEmit.status = status;
      this.$emit("courseOfferedDeleteModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
